import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import { noop, singleOrArray, stringOrFunction } from 'Helpers/PropTypes';

import NormalizedInput from '..';

class NumericInput extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange({ value }) {
    const { name, onChange } = this.props;
    onChange(name, value);
  }

  render() {
    const { handleChange } = this;
    const {
      className, isNumericOnly, min, name, onChange, ...rest
    } = this.props;

    return (
      <NormalizedInput>
        <NumberFormat
          {...rest}
          type={isNumericOnly ? 'tel' : 'text'}
          allowNegative={min < 0}
          className={`Numeric ${className}`}
          isNumericString
          onValueChange={handleChange}
          test={name}
        />
      </NormalizedInput>
    );
  }
}

NumericInput.propTypes = {
  className: PropTypes.string,
  decimalScale: PropTypes.number,
  isNumericOnly: PropTypes.bool,
  format: stringOrFunction,
  mask: singleOrArray(PropTypes.string),
  max: PropTypes.number,
  min: PropTypes.number,
  name: PropTypes.string.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  prefix: PropTypes.string,
  suffix: PropTypes.string,
  value: PropTypes.string,
};

NumericInput.defaultProps = {
  className: '',
  decimalScale: undefined,
  format: number => number,
  mask: ' ',
  max: Number.POSITIVE_INFINITY,
  min: Number.NEGATIVE_INFINITY,
  onBlur: noop,
  onChange: noop,
  placeholder: '',
  prefix: undefined,
  isNumericOnly: false,
  suffix: undefined,
  value: '',
};

export default NumericInput;
